import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'
// @ts-expect-error Legacy JavaScript module has no type declarations.
import { selectFilters } from '../../Customers/customers.selectors'
import { refreshCustomersAfterStoreDelinquency } from './update-store-delinquent'

type StartBillingRestrictionInput = {
	accountId: string
}

export const startBillingRestriction = ({ accountId }: StartBillingRestrictionInput): Promise<void> => {
	return api.post(`/BillingRestrictions/accounts/${accountId}/start`)
}

export const invalidateAfterBillingRestrictionStart = (queryClient: QueryClient, accountId: string) =>
	Promise.all([
		queryClient.invalidateQueries({
			queryKey: ['accounts', accountId],
			exact: true,
			refetchType: 'active',
		}),
		queryClient.invalidateQueries({
			queryKey: ['accounts', accountId, 'stores'],
			refetchType: 'active',
		}),
	])

type UseStartBillingRestrictionOptions = {
	mutationConfig?: MutationConfig<typeof startBillingRestriction>
}

export const useStartBillingRestriction = ({ mutationConfig }: UseStartBillingRestrictionOptions = {}) => {
	const queryClient = useQueryClient()
	const dispatch = useDispatch()
	const customerFilters = useSelector(selectFilters)
	const { onSuccess, onError, ...restConfig } = mutationConfig || {}

	return useMutation({
		mutationFn: startBillingRestriction,
		onSuccess: async (...args) => {
			await invalidateAfterBillingRestrictionStart(queryClient, args[1].accountId)
			await refreshCustomersAfterStoreDelinquency(dispatch, customerFilters)
			onSuccess?.(...args)
		},
		onError: async (...args) => {
			// A rejected start can still mean the state moved (paid during recheck, concurrent start).
			await invalidateAfterBillingRestrictionStart(queryClient, args[1].accountId)
			onError?.(...args)
		},
		...restConfig,
	})
}
